import { gql } from "@apollo/client";

export const acceptTermsAdditionalMutation = gql`mutation AcceptTerms($id: String!, $input: TermsInput!) {
  acceptTerms(id: $id, input: $input) 
}
`